module.exports = __webpack_public_path__ + "media/components/lesson1/common/statics/userDesign-7c68f47b570f7a34ee6bbc8c8fccbc38.gif";